// extracted by mini-css-extract-plugin
export default {"leader_container":"leader_leader_container__I4CTY","code_header_center":"leader_code_header_center__tcaVE"};